// Mock data for LÉLUNE — lelune.nl (frontend-only, browser cart)
// NOTE: All data here is MOCKED. Cart persists in localStorage only.

export const IMAGES = {
  // Actual serum (blue bottle + rose box)
  serum:
    "https://customer-assets-lqy194kg.emergentagent.net/job_b77ac488-14cb-4bcd-9589-87ef56f26d2b/artifacts/a1jcg7ih_015a606d-ecb0-4164-9739-dc8ea114e7ec.jpeg",
  // 4 lip tint tubes (shades 02, 03, 14, 20)
  lipTints:
    "https://customer-assets-lqy194kg.emergentagent.net/job_b77ac488-14cb-4bcd-9589-87ef56f26d2b/artifacts/dmwfw05n_4502afe9-0f8f-49a0-a785-db40e8e29fc0.jpeg",
  // Peptide lip tint range chart (decorative)
  lipRange:
    "https://customer-assets-lqy194kg.emergentagent.net/job_b77ac488-14cb-4bcd-9589-87ef56f26d2b/artifacts/maeginnq_a74e9e98-5f2e-4dab-9938-d7f83b84fd27.jpeg",
  // Lip gloss (official LÉLUNE product photo provided by client)
  lipGloss:
    "https://customer-assets-agu9un31.emergentagent.net/job_cosmetics-boutique-3/artifacts/n8xw5ufa_f0804b78-1307-4266-8381-71c3d48578d5.jpeg",
  // PDRN Pink Peptide Serum (official LÉLUNE product photo provided by client)
  pdrnSerum:
    "https://customer-assets-agu9un31.emergentagent.net/job_cosmetics-boutique-3/artifacts/eq4ackto_c6ed592b-4f7d-4796-b262-c1b5e878d907.jpeg",
  // Lip liner (terracotta pencil + pink box)
  lipliner:
    "https://customer-assets-agu9un31.emergentagent.net/job_cosmetics-boutique-3/artifacts/49gfmno0_f0804b78-1307-4266-8381-71c3d48578d5.jpeg",
};

// Lip tint shades offered (2, 3, 14, 20)
export const LIP_SHADES = [
  { code: "02", name: "Rose", hex: "#E86A93" },
  { code: "03", name: "Berry", hex: "#B5476B" },
  { code: "14", name: "Petal", hex: "#F3B9C6" },
  { code: "20", name: "Fuchsia", hex: "#E85BA6" },
];

// Lip liner shades offered (22, 23, 25, 26)
export const LIP_LINER_SHADES = [
  { code: "22", name: "Brick", hex: "#C0574A" },
  { code: "23", name: "Raspberry", hex: "#C51E52" },
  { code: "25", name: "Coral", hex: "#E17C82" },
  { code: "26", name: "Rose", hex: "#DDA2AB" },
];

export const PRODUCTS = [
  {
    id: "copper-peptide-serum-30ml",
    index: "01",
    tag: "SERUM",
    preorder: true,
    image: IMAGES.serum,
    price: 34.95,
    volume: "30 ml",
    category: { nl: "Serum · Huid & Hoofdhuid", en: "Serum · Skin & Scalp" },
    name: { nl: "Copper Peptide Complex 03", en: "Copper Peptide Complex 03" },
    subtitle: { nl: "Biomimetisch Herstelserum", en: "Biomimetic Repair Serum" },
    short: {
      nl: "Biomimetisch koperpeptide-serum, 30 ml. Herstelt en versterkt huid & hoofdhuid.",
      en: "Biomimetic copper peptide serum, 30 ml. Repairs and strengthens skin & scalp.",
    },
    desc: {
      nl: "Een geconcentreerd GHK-Cu koperpeptide complex dat de natuurlijke collageenaanmaak ondersteunt, de huidbarrière herstelt en de hoofdhuid in balans brengt. Licht van textuur, snel opneembaar.",
      en: "A concentrated GHK-Cu copper peptide complex that supports natural collagen synthesis, restores the skin barrier and rebalances the scalp. Lightweight, fast-absorbing texture.",
    },
    specs: [
      { k: { nl: "Inhoud", en: "Volume" }, v: "30 ml / 1.0 fl.oz" },
      { k: { nl: "Werkstof", en: "Active" }, v: "GHK-Cu Copper Peptide" },
      { k: { nl: "Gebruik", en: "Use" }, v: { nl: "Huid & Hoofdhuid", en: "Skin & Scalp" } },
      { k: { nl: "Levering", en: "Dispatch" }, v: { nl: "Pre-order · sept.", en: "Pre-order · Sept." } },
    ],
  },
  {
    id: "color-lip-tint",
    index: "02",
    tag: "LIP TINT",
    preorder: false,
    image: IMAGES.lipTints,
    price: 13.95,
    volume: "10 ml",
    shades: LIP_SHADES,
    category: { nl: "Lippen · Kleur", en: "Lips · Color" },
    name: { nl: "Color Lip Tint", en: "Color Lip Tint" },
    subtitle: { nl: "Peptide Lip Color", en: "Peptide Lip Color" },
    short: {
      nl: "Verzorgende kleur-lip tint met peptiden. Kies uit 4 tinten.",
      en: "Nourishing peptide color lip tint. Choose from 4 shades.",
    },
    desc: {
      nl: "Een lichtgewicht lip tint die kleur en verzorging combineert. Peptiden hydrateren en verzachten, terwijl de buildbare pigmenten een natuurlijke glans geven.",
      en: "A lightweight lip tint blending color and care. Peptides hydrate and soften while buildable pigments deliver a natural sheen.",
    },
    specs: [
      { k: { nl: "Inhoud", en: "Volume" }, v: "10 ml" },
      { k: { nl: "Tinten", en: "Shades" }, v: "02 · 03 · 14 · 20" },
      { k: { nl: "Finish", en: "Finish" }, v: { nl: "Glanzend", en: "Glossy" } },
      { k: { nl: "Levering", en: "Dispatch" }, v: { nl: "Vandaag verzonden", en: "Ships today" } },
    ],
  },
  {
    id: "lipliner",
    index: "03",
    tag: "LIP LINER",
    preorder: false,
    image: IMAGES.lipliner,
    price: 9.95,
    volume: "0.3 g",
    shades: LIP_LINER_SHADES,
    category: { nl: "Lippen · Definitie", en: "Lips · Definition" },
    name: { nl: "Lip Liner", en: "Lip Liner" },
    subtitle: { nl: "Precision Definer", en: "Precision Definer" },
    short: {
      nl: "Romige, langhoudende lip liner die de lippen perfect definieert. In 4 tinten.",
      en: "Creamy, long-wear lip liner that perfectly defines the lips. In 4 shades.",
    },
    desc: {
      nl: "Een romige, glijdende lip liner met peptiden die de contour van de lippen verfijnt en de kleur langer laat blijven.",
      en: "A creamy, gliding lip liner with peptides that refines the lip contour and makes colour last longer.",
    },
    specs: [
      { k: { nl: "Inhoud", en: "Volume" }, v: "0.3 g" },
      { k: { nl: "Tinten", en: "Shades" }, v: "22 · 23 · 25 · 26" },
      { k: { nl: "Finish", en: "Finish" }, v: { nl: "Matte crème", en: "Matte creme" } },
      { k: { nl: "Levering", en: "Dispatch" }, v: { nl: "Vandaag verzonden", en: "Ships today" } },
    ],
  },
  {
    id: "pdrn-pink-peptide-serum-30ml",
    index: "04",
    tag: "SERUM",
    preorder: false,
    image: IMAGES.pdrnSerum,
    price: 29.95,
    volume: "30 ml",
    category: { nl: "Serum · Huid & Glow", en: "Serum · Skin & Glow" },
    name: { nl: "PDRN Pink Peptide Serum", en: "PDRN Pink Peptide Serum" },
    subtitle: { nl: "Rose PDRN · 5 Peptide Complex", en: "Rose PDRN · 5 Peptide Complex" },
    short: {
      nl: "K-beauty glow-serum met Rose PDRN en 5 peptiden. Voor alle huidtypes.",
      en: "K-beauty glow serum with Rose PDRN and 5 peptides. For all skin types.",
    },
    desc: {
      nl: "Een roze glow-serum geïnspireerd op K-beauty, met Rose PDRN en een complex van 5 peptiden. Hydrateert diep, versterkt de huidbarrière en geeft een gezonde, stralende teint. Geschikt voor alle huidtypes.",
      en: "A pink glow serum inspired by K-beauty, with Rose PDRN and a 5-peptide complex. Deeply hydrates, strengthens the skin barrier and delivers a healthy, radiant complexion. Suitable for all skin types.",
    },
    specs: [
      { k: { nl: "Inhoud", en: "Volume" }, v: "30 ml / 1.01 fl.oz" },
      { k: { nl: "Werkstof", en: "Active" }, v: "Rose PDRN + 5 Peptide Complex" },
      { k: { nl: "Huidtype", en: "Skin type" }, v: { nl: "Alle huidtypes", en: "All skin types" } },
      { k: { nl: "Levering", en: "Dispatch" }, v: { nl: "Vandaag verzonden", en: "Ships today" } },
    ],
  },
];

export const REVIEWS = [
  { name: "Sanne D.", rating: 5, nl: "De serum voelt luxe en mijn huid is zichtbaar rustiger.", en: "The serum feels luxurious and my skin looks visibly calmer." },
  { name: "Emma V.", rating: 5, nl: "Tint 03 is mijn favoriet — mooie kleur, niet plakkerig.", en: "Shade 03 is my favourite — beautiful colour, not sticky." },
  { name: "Lotte B.", rating: 5, nl: "Snelle verzending vanuit Nederland. Prachtige verpakking.", en: "Fast shipping from the Netherlands. Gorgeous packaging." },
];

export const T = {
  nl: {
    announce: "Zomer edit · gratis verzending vanaf €100",
    shopNow: "Shop nu",
    marquee: [
      "Gratis NL-verzending vanaf €100",
      "Voor 15:00 besteld = vandaag verzonden",
      "Dermatologisch getest",
      "Cruelty-free & vegan",
    ],
    navHome: "Home",
    navShop: "Shop",
    navRitual: "Ritueel",
    navAbout: "Over ons",
    heroKicker: "Huidverzorging & Lippen",
    heroTitle1: "Zachte kracht.",
    heroTitle2: "Peptide huidverzorging.",
    heroTitle3: "Made in NL.",
    heroText:
      "LÉLUNE combineert biomimetische peptiden met een minimalistisch ritueel. Verzorging die je huid en lippen laat stralen — puur, doeltreffend, mooi.",
    heroCta1: "Bekijk collectie",
    heroCta2: "Ons verhaal",
    live: "LIVE · Voor 15:00 = vandaag verzonden",
    stat1: "Natuurlijke werkstoffen",
    stat2: "NL verzending",
    stat3: "Blije klanten",
    catKicker: "02 · COLLECTIE",
    catTitle: "De complete ritueel-set. Eén standaard.",
    catText: "Elk product is met zorg samengesteld en dermatologisch getest. Prijzen inclusief btw.",
    viewProduct: "Bekijk product",
    addToCart: "In winkelmand",
    preorder: "Pre-order",
    preorderCta: "Pre-order nu",
    chooseShade: "Kies je tint",
    orderKicker: "03 · BESTEL NU",
    orderTitle: "Vandaag besteld.",
    orderTitle2: "Morgen in huis.",
    orderText:
      "Bestel voor 15:00 — dezelfde dag verzonden vanuit Nederland. Getraceerd en zorgvuldig verpakt.",
    nextDispatch: "Volgende verzending over",
    orderCta: "Direct bestellen",
    perk1: "Gratis verzending > €100",
    perk2: "Dermatologisch getest",
    perk3: "Veilig betalen",
    perk4: "Discrete verpakking",
    manifestoKicker: "04 · MANIFEST",
    manifestoTitle: "Wat schoonheid voor ons betekent.",
    chapters: [
      { t: "Biomimetische peptiden", d: "Werkstoffen die de taal van je huid spreken — voor zichtbaar herstel." },
      { t: "Clean formules", d: "Zonder onnodige toevoegingen. Vegan, cruelty-free en dermatologisch getest." },
      { t: "Transparante herkomst", d: "Grondstoffen uit gecertificeerde faciliteiten. Volledig gedocumenteerd." },
      { t: "Snelle EU-verzending", d: "Binnen 24 uur verzonden vanuit Nederland. Getraceerd en zorgvuldig verpakt." },
    ],
    reviewsTitle: "Geliefd door onze klanten",
    payKicker: "05 · BETALEN",
    payTitle: "Betaal veilig met de methode die je vertrouwt.",
    payText: "Verwerkt via Stripe — Europees, PSD2-conform en versleuteld.",
    cart: "Winkelmand",
    cartEmpty: "Je winkelmand is leeg.",
    subtotal: "Subtotaal",
    checkout: "Afrekenen",
    continue: "Verder winkelen",
    remove: "Verwijderen",
    shade: "Tint",
    qty: "Aantal",
    checkoutNote: "Dit is een demo — betaling is nog niet actief.",
    checkoutSecure: "Veilig afrekenen via Stripe.",
    footerTag: "Peptide huidverzorging, gemaakt in Nederland.",
    footerShop: "Shop",
    footerHelp: "Hulp",
    footerAbout: "Bedrijf",
    rights: "Alle rechten voorbehouden.",
    newsletter: "Schrijf je in voor 10% korting",
    subscribe: "Inschrijven",
    emailPlaceholder: "Jouw e-mailadres",
    subscribed: "Bedankt voor je inschrijving!",
  },
  en: {
    announce: "Summer edit · free shipping over €100",
    shopNow: "Shop now",
    marquee: [
      "Free NL shipping over €100",
      "Order by 3PM = ships today",
      "Dermatologically tested",
      "Cruelty-free & vegan",
    ],
    navHome: "Home",
    navShop: "Shop",
    navRitual: "Ritual",
    navAbout: "About",
    heroKicker: "Skincare & Lips",
    heroTitle1: "Gentle power.",
    heroTitle2: "Peptide skincare.",
    heroTitle3: "Made in NL.",
    heroText:
      "LÉLUNE blends biomimetic peptides with a minimalist ritual. Care that lets your skin and lips glow — pure, effective, beautiful.",
    heroCta1: "View collection",
    heroCta2: "Our story",
    live: "LIVE · Order by 3PM = ships today",
    stat1: "Natural actives",
    stat2: "NL dispatch",
    stat3: "Happy customers",
    catKicker: "02 · COLLECTION",
    catTitle: "The complete ritual set. One standard.",
    catText: "Every product is carefully formulated and dermatologically tested. Prices including VAT.",
    viewProduct: "View product",
    addToCart: "Add to cart",
    preorder: "Pre-order",
    preorderCta: "Pre-order now",
    chooseShade: "Choose your shade",
    orderKicker: "03 · ORDER NOW",
    orderTitle: "Order today.",
    orderTitle2: "At home tomorrow.",
    orderText:
      "Order before 3PM — dispatched same day from the Netherlands. Tracked and carefully packaged.",
    nextDispatch: "Next dispatch in",
    orderCta: "Order directly",
    perk1: "Free shipping > €100",
    perk2: "Dermatologically tested",
    perk3: "Secure payment",
    perk4: "Discreet packaging",
    manifestoKicker: "04 · MANIFESTO",
    manifestoTitle: "What beauty means to us.",
    chapters: [
      { t: "Biomimetic peptides", d: "Actives that speak your skin's language — for visible repair." },
      { t: "Clean formulas", d: "No unnecessary additives. Vegan, cruelty-free and dermatologically tested." },
      { t: "Transparent origin", d: "Raw materials from certified facilities. Fully documented." },
      { t: "Fast EU shipping", d: "Dispatched within 24 hours from the Netherlands. Tracked and carefully packaged." },
    ],
    reviewsTitle: "Loved by our customers",
    payKicker: "05 · PAYMENTS",
    payTitle: "Pay securely with the method you trust.",
    payText: "Processed via Stripe — European, PSD2 compliant and encrypted.",
    cart: "Cart",
    cartEmpty: "Your cart is empty.",
    subtotal: "Subtotal",
    checkout: "Checkout",
    continue: "Continue shopping",
    remove: "Remove",
    shade: "Shade",
    qty: "Qty",
    checkoutNote: "This is a demo — payment is not active yet.",
    checkoutSecure: "Secure checkout via Stripe.",
    footerTag: "Peptide skincare, made in the Netherlands.",
    footerShop: "Shop",
    footerHelp: "Help",
    footerAbout: "Company",
    rights: "All rights reserved.",
    newsletter: "Sign up for 10% off",
    subscribe: "Subscribe",
    emailPlaceholder: "Your email address",
    subscribed: "Thanks for subscribing!",
  },
};
